
// @ts-nocheck


export const localeCodes =  [
  "aplus_de",
  "aplus_en",
  "aplus_fr",
  "aplus_it",
  "ageingsociety_de",
  "ageingsociety_fr",
  "integrity_de",
  "integrity_en",
  "integrity_fr",
  "integrity_it",
  "ord_de",
  "ord_en",
  "ord_fr",
  "ord_it",
  "polarresearch_de",
  "polarresearch_en",
  "polarresearch_fr",
  "nsan_de",
  "nsan_en",
  "nsan_fr",
  "nsan_it",
  "prixmedia_de",
  "prixmedia_en",
  "prixmedia_fr",
  "prixmedia_it",
  "tdnet_de",
  "tdnet_en",
  "tdnet_fr",
  "tdnet_it",
  "youngacademy_de",
  "youngacademy_en",
  "youngacademy_fr",
  "youngacademy_it"
]

export const localeLoaders = {
  "aplus_de": [{ key: "../lang/de.json", load: () => import("../lang/de.json" /* webpackChunkName: "locale__vercel_path0_lang_de_json" */), cache: true }],
  "aplus_en": [{ key: "../lang/en.json", load: () => import("../lang/en.json" /* webpackChunkName: "locale__vercel_path0_lang_en_json" */), cache: true }],
  "aplus_fr": [{ key: "../lang/fr.json", load: () => import("../lang/fr.json" /* webpackChunkName: "locale__vercel_path0_lang_fr_json" */), cache: true }],
  "aplus_it": [{ key: "../lang/it.json", load: () => import("../lang/it.json" /* webpackChunkName: "locale__vercel_path0_lang_it_json" */), cache: true }],
  "ageingsociety_de": [{ key: "../lang/de.json", load: () => import("../lang/de.json" /* webpackChunkName: "locale__vercel_path0_lang_de_json" */), cache: true }],
  "ageingsociety_fr": [{ key: "../lang/fr.json", load: () => import("../lang/fr.json" /* webpackChunkName: "locale__vercel_path0_lang_fr_json" */), cache: true }],
  "integrity_de": [{ key: "../lang/de.json", load: () => import("../lang/de.json" /* webpackChunkName: "locale__vercel_path0_lang_de_json" */), cache: true }],
  "integrity_en": [{ key: "../lang/en.json", load: () => import("../lang/en.json" /* webpackChunkName: "locale__vercel_path0_lang_en_json" */), cache: true }],
  "integrity_fr": [{ key: "../lang/fr.json", load: () => import("../lang/fr.json" /* webpackChunkName: "locale__vercel_path0_lang_fr_json" */), cache: true }],
  "integrity_it": [{ key: "../lang/it.json", load: () => import("../lang/it.json" /* webpackChunkName: "locale__vercel_path0_lang_it_json" */), cache: true }],
  "ord_de": [{ key: "../lang/de.json", load: () => import("../lang/de.json" /* webpackChunkName: "locale__vercel_path0_lang_de_json" */), cache: true }],
  "ord_en": [{ key: "../lang/en.json", load: () => import("../lang/en.json" /* webpackChunkName: "locale__vercel_path0_lang_en_json" */), cache: true }],
  "ord_fr": [{ key: "../lang/fr.json", load: () => import("../lang/fr.json" /* webpackChunkName: "locale__vercel_path0_lang_fr_json" */), cache: true }],
  "ord_it": [{ key: "../lang/it.json", load: () => import("../lang/it.json" /* webpackChunkName: "locale__vercel_path0_lang_it_json" */), cache: true }],
  "polarresearch_de": [{ key: "../lang/de.json", load: () => import("../lang/de.json" /* webpackChunkName: "locale__vercel_path0_lang_de_json" */), cache: true }],
  "polarresearch_en": [{ key: "../lang/en.json", load: () => import("../lang/en.json" /* webpackChunkName: "locale__vercel_path0_lang_en_json" */), cache: true }],
  "polarresearch_fr": [{ key: "../lang/fr.json", load: () => import("../lang/fr.json" /* webpackChunkName: "locale__vercel_path0_lang_fr_json" */), cache: true }],
  "nsan_de": [{ key: "../lang/de.json", load: () => import("../lang/de.json" /* webpackChunkName: "locale__vercel_path0_lang_de_json" */), cache: true }],
  "nsan_en": [{ key: "../lang/en.json", load: () => import("../lang/en.json" /* webpackChunkName: "locale__vercel_path0_lang_en_json" */), cache: true }],
  "nsan_fr": [{ key: "../lang/fr.json", load: () => import("../lang/fr.json" /* webpackChunkName: "locale__vercel_path0_lang_fr_json" */), cache: true }],
  "nsan_it": [{ key: "../lang/it.json", load: () => import("../lang/it.json" /* webpackChunkName: "locale__vercel_path0_lang_it_json" */), cache: true }],
  "prixmedia_de": [{ key: "../lang/de.json", load: () => import("../lang/de.json" /* webpackChunkName: "locale__vercel_path0_lang_de_json" */), cache: true }],
  "prixmedia_en": [{ key: "../lang/en.json", load: () => import("../lang/en.json" /* webpackChunkName: "locale__vercel_path0_lang_en_json" */), cache: true }],
  "prixmedia_fr": [{ key: "../lang/fr.json", load: () => import("../lang/fr.json" /* webpackChunkName: "locale__vercel_path0_lang_fr_json" */), cache: true }],
  "prixmedia_it": [{ key: "../lang/it.json", load: () => import("../lang/it.json" /* webpackChunkName: "locale__vercel_path0_lang_it_json" */), cache: true }],
  "tdnet_de": [{ key: "../lang/de.json", load: () => import("../lang/de.json" /* webpackChunkName: "locale__vercel_path0_lang_de_json" */), cache: true }],
  "tdnet_en": [{ key: "../lang/en.json", load: () => import("../lang/en.json" /* webpackChunkName: "locale__vercel_path0_lang_en_json" */), cache: true }],
  "tdnet_fr": [{ key: "../lang/fr.json", load: () => import("../lang/fr.json" /* webpackChunkName: "locale__vercel_path0_lang_fr_json" */), cache: true }],
  "tdnet_it": [{ key: "../lang/it.json", load: () => import("../lang/it.json" /* webpackChunkName: "locale__vercel_path0_lang_it_json" */), cache: true }],
  "youngacademy_de": [{ key: "../lang/de.json", load: () => import("../lang/de.json" /* webpackChunkName: "locale__vercel_path0_lang_de_json" */), cache: true }],
  "youngacademy_en": [{ key: "../lang/en.json", load: () => import("../lang/en.json" /* webpackChunkName: "locale__vercel_path0_lang_en_json" */), cache: true }],
  "youngacademy_fr": [{ key: "../lang/fr.json", load: () => import("../lang/fr.json" /* webpackChunkName: "locale__vercel_path0_lang_fr_json" */), cache: true }],
  "youngacademy_it": [{ key: "../lang/it.json", load: () => import("../lang/it.json" /* webpackChunkName: "locale__vercel_path0_lang_it_json" */), cache: true }]
}

export const vueI18nConfigs = [
  
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "",
  "locales": [
    {
      "code": "aplus_de",
      "name": "Deutsch",
      "language": "de-CH",
      "languageTag": "de",
      "isMain": true,
      "domain": "akademien-schweiz.ch",
      "domainDefault": true,
      "files": [
        "/vercel/path0/lang/de.json"
      ]
    },
    {
      "code": "aplus_en",
      "name": "English",
      "language": "en",
      "languageTag": "en",
      "isMain": true,
      "domain": "swiss-academies.ch",
      "domainDefault": true,
      "files": [
        "/vercel/path0/lang/en.json"
      ]
    },
    {
      "code": "aplus_fr",
      "name": "Français",
      "language": "fr-CH",
      "languageTag": "fr",
      "isMain": true,
      "domain": "academies-suisses.ch",
      "domainDefault": true,
      "files": [
        "/vercel/path0/lang/fr.json"
      ]
    },
    {
      "code": "aplus_it",
      "name": "Italiano",
      "language": "it-CH",
      "languageTag": "it",
      "isMain": true,
      "domain": "accademie-svizzere.ch",
      "domainDefault": true,
      "files": [
        "/vercel/path0/lang/it.json"
      ]
    },
    {
      "code": "ageingsociety_de",
      "name": "Deutsch",
      "language": "de-CH",
      "languageTag": "de",
      "domain": "de.ageingsociety.ch",
      "domainDefault": true,
      "files": [
        "/vercel/path0/lang/de.json"
      ]
    },
    {
      "code": "ageingsociety_fr",
      "name": "Français",
      "language": "fr-CH",
      "languageTag": "fr",
      "domain": "fr.ageingsociety.ch",
      "domainDefault": true,
      "files": [
        "/vercel/path0/lang/fr.json"
      ]
    },
    {
      "code": "integrity_de",
      "name": "Deutsch",
      "language": "de-CH",
      "languageTag": "de",
      "domain": "wissenschaftliche-integritaet.ch",
      "domainDefault": true,
      "files": [
        "/vercel/path0/lang/de.json"
      ]
    },
    {
      "code": "integrity_en",
      "name": "English",
      "language": "en",
      "languageTag": "en",
      "domain": "scientific-integrity.ch",
      "domainDefault": true,
      "files": [
        "/vercel/path0/lang/en.json"
      ]
    },
    {
      "code": "integrity_fr",
      "name": "Français",
      "language": "fr-CH",
      "languageTag": "fr",
      "domain": "integrite-scientifique.ch",
      "domainDefault": true,
      "files": [
        "/vercel/path0/lang/fr.json"
      ]
    },
    {
      "code": "integrity_it",
      "name": "Italiano",
      "language": "it-CH",
      "languageTag": "it",
      "domain": "integrita-scientifica.ch",
      "domainDefault": true,
      "files": [
        "/vercel/path0/lang/it.json"
      ]
    },
    {
      "code": "ord_de",
      "name": "Deutsch",
      "language": "de-CH",
      "languageTag": "de",
      "domain": "ord.akademien-schweiz.ch",
      "domainDefault": true,
      "files": [
        "/vercel/path0/lang/de.json"
      ]
    },
    {
      "code": "ord_en",
      "name": "English",
      "language": "en",
      "languageTag": "en",
      "domain": "ord.swiss-academies.ch",
      "domainDefault": true,
      "files": [
        "/vercel/path0/lang/en.json"
      ]
    },
    {
      "code": "ord_fr",
      "name": "Français",
      "language": "fr-CH",
      "languageTag": "fr",
      "domain": "ord.academies-suisses.ch",
      "domainDefault": true,
      "files": [
        "/vercel/path0/lang/fr.json"
      ]
    },
    {
      "code": "ord_it",
      "name": "Italiano",
      "language": "it-CH",
      "languageTag": "it",
      "domain": "ord.accademie-svizzere.ch",
      "domainDefault": true,
      "files": [
        "/vercel/path0/lang/it.json"
      ]
    },
    {
      "code": "polarresearch_de",
      "name": "Deutsch",
      "language": "de-CH",
      "languageTag": "de",
      "domain": "polarforschung.ch",
      "domainDefault": true,
      "files": [
        "/vercel/path0/lang/de.json"
      ]
    },
    {
      "code": "polarresearch_en",
      "name": "English",
      "language": "en",
      "languageTag": "en",
      "domain": "polar-research.ch",
      "domainDefault": true,
      "files": [
        "/vercel/path0/lang/en.json"
      ]
    },
    {
      "code": "polarresearch_fr",
      "name": "Français",
      "language": "fr-CH",
      "languageTag": "fr",
      "domain": "recherche-polaire.ch",
      "domainDefault": true,
      "files": [
        "/vercel/path0/lang/fr.json"
      ]
    },
    {
      "code": "nsan_de",
      "name": "Deutsch",
      "language": "de-CH",
      "languageTag": "de",
      "domain": "netzwerk-wissenschaftliche-beratung.ch",
      "domainDefault": true,
      "files": [
        "/vercel/path0/lang/de.json"
      ]
    },
    {
      "code": "nsan_en",
      "name": "English",
      "language": "en",
      "languageTag": "en",
      "domain": "science-advice-network.ch",
      "files": [
        "/vercel/path0/lang/en.json"
      ]
    },
    {
      "code": "nsan_fr",
      "name": "Français",
      "language": "fr-CH",
      "languageTag": "fr",
      "domain": "reseau-conseil-scientifique.ch",
      "domainDefault": true,
      "files": [
        "/vercel/path0/lang/fr.json"
      ]
    },
    {
      "code": "nsan_it",
      "name": "Italiano",
      "language": "it-CH",
      "languageTag": "it",
      "domain": "rete-consulenza-scientifica.ch",
      "domainDefault": true,
      "files": [
        "/vercel/path0/lang/it.json"
      ]
    },
    {
      "code": "prixmedia_de",
      "name": "Deutsch",
      "language": "de-CH",
      "languageTag": "de",
      "domain": "de.prixmedia.ch",
      "domainDefault": true,
      "files": [
        "/vercel/path0/lang/de.json"
      ]
    },
    {
      "code": "prixmedia_en",
      "name": "English",
      "language": "en",
      "languageTag": "en",
      "domain": "en.prixmedia.ch",
      "domainDefault": true,
      "files": [
        "/vercel/path0/lang/en.json"
      ]
    },
    {
      "code": "prixmedia_fr",
      "name": "Français",
      "language": "fr-CH",
      "languageTag": "fr",
      "domain": "fr.prixmedia.ch",
      "domainDefault": true,
      "files": [
        "/vercel/path0/lang/fr.json"
      ]
    },
    {
      "code": "prixmedia_it",
      "name": "Italiano",
      "language": "it-CH",
      "languageTag": "it",
      "domain": "it.prixmedia.ch",
      "domainDefault": true,
      "files": [
        "/vercel/path0/lang/it.json"
      ]
    },
    {
      "code": "tdnet_de",
      "name": "Deutsch",
      "language": "de-CH",
      "languageTag": "de",
      "domain": "de.transdisciplinarity.ch",
      "domainDefault": true,
      "files": [
        "/vercel/path0/lang/de.json"
      ]
    },
    {
      "code": "tdnet_en",
      "name": "English",
      "language": "en",
      "languageTag": "en",
      "domain": "en.transdisciplinarity.ch",
      "domainDefault": true,
      "files": [
        "/vercel/path0/lang/en.json"
      ]
    },
    {
      "code": "tdnet_fr",
      "name": "Français",
      "language": "fr-CH",
      "languageTag": "fr",
      "domain": "fr.transdisciplinarity.ch",
      "domainDefault": true,
      "files": [
        "/vercel/path0/lang/fr.json"
      ]
    },
    {
      "code": "tdnet_it",
      "name": "Italiano",
      "language": "it-CH",
      "languageTag": "it",
      "domain": "it.transdisciplinarity.ch",
      "domainDefault": true,
      "files": [
        "/vercel/path0/lang/it.json"
      ]
    },
    {
      "code": "youngacademy_de",
      "name": "Deutsch",
      "language": "de-CH",
      "languageTag": "de",
      "domain": "de.swissyoungacademy.ch",
      "domainDefault": true,
      "files": [
        "/vercel/path0/lang/de.json"
      ]
    },
    {
      "code": "youngacademy_en",
      "name": "English",
      "language": "en",
      "languageTag": "en",
      "domain": "en.swissyoungacademy.ch",
      "domainDefault": true,
      "files": [
        "/vercel/path0/lang/en.json"
      ]
    },
    {
      "code": "youngacademy_fr",
      "name": "Français",
      "language": "fr-CH",
      "languageTag": "fr",
      "domain": "fr.swissyoungacademy.ch",
      "domainDefault": true,
      "files": [
        "/vercel/path0/lang/fr.json"
      ]
    },
    {
      "code": "youngacademy_it",
      "name": "Italiano",
      "language": "it-CH",
      "languageTag": "it",
      "domain": "it.swissyoungacademy.ch",
      "domainDefault": true,
      "files": [
        "/vercel/path0/lang/it.json"
      ]
    }
  ],
  "defaultLocale": "aplus_de",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix_except_default",
  "lazy": true,
  "langDir": "lang/",
  "detectBrowserLanguage": false,
  "differentDomains": true,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "multiDomainLocales": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "aplus_de",
    "name": "Deutsch",
    "language": "de-CH",
    "languageTag": "de",
    "isMain": true,
    "domain": "akademien-schweiz.ch",
    "domainDefault": true,
    "files": [
      {
        "path": "/vercel/path0/lang/de.json"
      }
    ]
  },
  {
    "code": "aplus_en",
    "name": "English",
    "language": "en",
    "languageTag": "en",
    "isMain": true,
    "domain": "swiss-academies.ch",
    "domainDefault": true,
    "files": [
      {
        "path": "/vercel/path0/lang/en.json"
      }
    ]
  },
  {
    "code": "aplus_fr",
    "name": "Français",
    "language": "fr-CH",
    "languageTag": "fr",
    "isMain": true,
    "domain": "academies-suisses.ch",
    "domainDefault": true,
    "files": [
      {
        "path": "/vercel/path0/lang/fr.json"
      }
    ]
  },
  {
    "code": "aplus_it",
    "name": "Italiano",
    "language": "it-CH",
    "languageTag": "it",
    "isMain": true,
    "domain": "accademie-svizzere.ch",
    "domainDefault": true,
    "files": [
      {
        "path": "/vercel/path0/lang/it.json"
      }
    ]
  },
  {
    "code": "ageingsociety_de",
    "name": "Deutsch",
    "language": "de-CH",
    "languageTag": "de",
    "domain": "de.ageingsociety.ch",
    "domainDefault": true,
    "files": [
      {
        "path": "/vercel/path0/lang/de.json"
      }
    ]
  },
  {
    "code": "ageingsociety_fr",
    "name": "Français",
    "language": "fr-CH",
    "languageTag": "fr",
    "domain": "fr.ageingsociety.ch",
    "domainDefault": true,
    "files": [
      {
        "path": "/vercel/path0/lang/fr.json"
      }
    ]
  },
  {
    "code": "integrity_de",
    "name": "Deutsch",
    "language": "de-CH",
    "languageTag": "de",
    "domain": "wissenschaftliche-integritaet.ch",
    "domainDefault": true,
    "files": [
      {
        "path": "/vercel/path0/lang/de.json"
      }
    ]
  },
  {
    "code": "integrity_en",
    "name": "English",
    "language": "en",
    "languageTag": "en",
    "domain": "scientific-integrity.ch",
    "domainDefault": true,
    "files": [
      {
        "path": "/vercel/path0/lang/en.json"
      }
    ]
  },
  {
    "code": "integrity_fr",
    "name": "Français",
    "language": "fr-CH",
    "languageTag": "fr",
    "domain": "integrite-scientifique.ch",
    "domainDefault": true,
    "files": [
      {
        "path": "/vercel/path0/lang/fr.json"
      }
    ]
  },
  {
    "code": "integrity_it",
    "name": "Italiano",
    "language": "it-CH",
    "languageTag": "it",
    "domain": "integrita-scientifica.ch",
    "domainDefault": true,
    "files": [
      {
        "path": "/vercel/path0/lang/it.json"
      }
    ]
  },
  {
    "code": "ord_de",
    "name": "Deutsch",
    "language": "de-CH",
    "languageTag": "de",
    "domain": "ord.akademien-schweiz.ch",
    "domainDefault": true,
    "files": [
      {
        "path": "/vercel/path0/lang/de.json"
      }
    ]
  },
  {
    "code": "ord_en",
    "name": "English",
    "language": "en",
    "languageTag": "en",
    "domain": "ord.swiss-academies.ch",
    "domainDefault": true,
    "files": [
      {
        "path": "/vercel/path0/lang/en.json"
      }
    ]
  },
  {
    "code": "ord_fr",
    "name": "Français",
    "language": "fr-CH",
    "languageTag": "fr",
    "domain": "ord.academies-suisses.ch",
    "domainDefault": true,
    "files": [
      {
        "path": "/vercel/path0/lang/fr.json"
      }
    ]
  },
  {
    "code": "ord_it",
    "name": "Italiano",
    "language": "it-CH",
    "languageTag": "it",
    "domain": "ord.accademie-svizzere.ch",
    "domainDefault": true,
    "files": [
      {
        "path": "/vercel/path0/lang/it.json"
      }
    ]
  },
  {
    "code": "polarresearch_de",
    "name": "Deutsch",
    "language": "de-CH",
    "languageTag": "de",
    "domain": "polarforschung.ch",
    "domainDefault": true,
    "files": [
      {
        "path": "/vercel/path0/lang/de.json"
      }
    ]
  },
  {
    "code": "polarresearch_en",
    "name": "English",
    "language": "en",
    "languageTag": "en",
    "domain": "polar-research.ch",
    "domainDefault": true,
    "files": [
      {
        "path": "/vercel/path0/lang/en.json"
      }
    ]
  },
  {
    "code": "polarresearch_fr",
    "name": "Français",
    "language": "fr-CH",
    "languageTag": "fr",
    "domain": "recherche-polaire.ch",
    "domainDefault": true,
    "files": [
      {
        "path": "/vercel/path0/lang/fr.json"
      }
    ]
  },
  {
    "code": "nsan_de",
    "name": "Deutsch",
    "language": "de-CH",
    "languageTag": "de",
    "domain": "netzwerk-wissenschaftliche-beratung.ch",
    "domainDefault": true,
    "files": [
      {
        "path": "/vercel/path0/lang/de.json"
      }
    ]
  },
  {
    "code": "nsan_en",
    "name": "English",
    "language": "en",
    "languageTag": "en",
    "domain": "science-advice-network.ch",
    "files": [
      {
        "path": "/vercel/path0/lang/en.json"
      }
    ]
  },
  {
    "code": "nsan_fr",
    "name": "Français",
    "language": "fr-CH",
    "languageTag": "fr",
    "domain": "reseau-conseil-scientifique.ch",
    "domainDefault": true,
    "files": [
      {
        "path": "/vercel/path0/lang/fr.json"
      }
    ]
  },
  {
    "code": "nsan_it",
    "name": "Italiano",
    "language": "it-CH",
    "languageTag": "it",
    "domain": "rete-consulenza-scientifica.ch",
    "domainDefault": true,
    "files": [
      {
        "path": "/vercel/path0/lang/it.json"
      }
    ]
  },
  {
    "code": "prixmedia_de",
    "name": "Deutsch",
    "language": "de-CH",
    "languageTag": "de",
    "domain": "de.prixmedia.ch",
    "domainDefault": true,
    "files": [
      {
        "path": "/vercel/path0/lang/de.json"
      }
    ]
  },
  {
    "code": "prixmedia_en",
    "name": "English",
    "language": "en",
    "languageTag": "en",
    "domain": "en.prixmedia.ch",
    "domainDefault": true,
    "files": [
      {
        "path": "/vercel/path0/lang/en.json"
      }
    ]
  },
  {
    "code": "prixmedia_fr",
    "name": "Français",
    "language": "fr-CH",
    "languageTag": "fr",
    "domain": "fr.prixmedia.ch",
    "domainDefault": true,
    "files": [
      {
        "path": "/vercel/path0/lang/fr.json"
      }
    ]
  },
  {
    "code": "prixmedia_it",
    "name": "Italiano",
    "language": "it-CH",
    "languageTag": "it",
    "domain": "it.prixmedia.ch",
    "domainDefault": true,
    "files": [
      {
        "path": "/vercel/path0/lang/it.json"
      }
    ]
  },
  {
    "code": "tdnet_de",
    "name": "Deutsch",
    "language": "de-CH",
    "languageTag": "de",
    "domain": "de.transdisciplinarity.ch",
    "domainDefault": true,
    "files": [
      {
        "path": "/vercel/path0/lang/de.json"
      }
    ]
  },
  {
    "code": "tdnet_en",
    "name": "English",
    "language": "en",
    "languageTag": "en",
    "domain": "en.transdisciplinarity.ch",
    "domainDefault": true,
    "files": [
      {
        "path": "/vercel/path0/lang/en.json"
      }
    ]
  },
  {
    "code": "tdnet_fr",
    "name": "Français",
    "language": "fr-CH",
    "languageTag": "fr",
    "domain": "fr.transdisciplinarity.ch",
    "domainDefault": true,
    "files": [
      {
        "path": "/vercel/path0/lang/fr.json"
      }
    ]
  },
  {
    "code": "tdnet_it",
    "name": "Italiano",
    "language": "it-CH",
    "languageTag": "it",
    "domain": "it.transdisciplinarity.ch",
    "domainDefault": true,
    "files": [
      {
        "path": "/vercel/path0/lang/it.json"
      }
    ]
  },
  {
    "code": "youngacademy_de",
    "name": "Deutsch",
    "language": "de-CH",
    "languageTag": "de",
    "domain": "de.swissyoungacademy.ch",
    "domainDefault": true,
    "files": [
      {
        "path": "/vercel/path0/lang/de.json"
      }
    ]
  },
  {
    "code": "youngacademy_en",
    "name": "English",
    "language": "en",
    "languageTag": "en",
    "domain": "en.swissyoungacademy.ch",
    "domainDefault": true,
    "files": [
      {
        "path": "/vercel/path0/lang/en.json"
      }
    ]
  },
  {
    "code": "youngacademy_fr",
    "name": "Français",
    "language": "fr-CH",
    "languageTag": "fr",
    "domain": "fr.swissyoungacademy.ch",
    "domainDefault": true,
    "files": [
      {
        "path": "/vercel/path0/lang/fr.json"
      }
    ]
  },
  {
    "code": "youngacademy_it",
    "name": "Italiano",
    "language": "it-CH",
    "languageTag": "it",
    "domain": "it.swissyoungacademy.ch",
    "domainDefault": true,
    "files": [
      {
        "path": "/vercel/path0/lang/it.json"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
